import React from 'react';
import { Nav } from 'react-bootstrap';
import '../../../ManageTournaments/ManageTournaments.css';

interface Tab {
  key: string;
  label: string;
  icon?: string;
}

interface ShopTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  className?: string;
}

const ShopTabs: React.FC<ShopTabsProps> = ({ tabs, activeTab, onTabChange, className = '' }) => {
  return (
    <Nav variant="tabs" className={`tournament-tabs mb-4 ${className}`}>
      {tabs.map((tab) => (
        <Nav.Item key={tab.key}>
          <Nav.Link
            className="tournament-tab"
            active={activeTab === tab.key}
            onClick={() => onTabChange(tab.key)}
          >
            {tab.icon && <i className={`${tab.icon} me-2`}></i>}
            {tab.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default ShopTabs;
